import { render, staticRenderFns } from "./AddCompanyComponent.vue?vue&type=template&id=150c7c94&"
import script from "./AddCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./AddCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports